/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRoom } from 'app/shared/model/room.model';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';

export interface IBed {
  id?: string;
  name?: string | null;
  bedNumber?: string | null;
  tempClosed?: boolean | null;
  dateClosed?: number | null;
  description?: string | null;
  modifiedBy?: string | null;
  modifiedTime?: number | null;
  createdBy?: string | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  charge?: number | null;
  chargeType?: keyof typeof ChargeType | null;
  allotted?: boolean | null;
  room?: IRoom;
}

export const defaultValue: Readonly<IBed> = {
  tempClosed: false,
  active: false,
  allotted: false,
};
